<script>
    //exports
    export let data;
    export let align = data.blockAlignment;
    export let bg = data.blockBackgroundColor;
    export let bgImage = data.blockBackgroundImage;
    export let customStyles = data.blockCustomStyles;
    export let classes = data.blockClasses;
    export let id = data.blockID;
    export let fontColor = data.blockFontColor;

    //console.log('Section Hero', data)

    //local variables
    let y;
    let clientWidth;
</script>

<style>
    .svg-icon {
      display: inline-block;
      align-self: center;
    }

    .svg-icon svg {
      height:1.2em;
      width:1.2em;
    }

    .svg-icon.svg-baseline svg {
      top: .125em;
      position: relative;
      filter: drop-shadow(0px 8px 12px rgba(1, 122, 196, 0.1));
    }
</style>

<svelte:window bind:scrollY={y} bind:innerWidth={clientWidth} />

{#if clientWidth > 1024}
 
  <div class="text-{align} h-screen relative" style="color: {fontColor}; background-color: {bg};" id={id} data-aos="fade">

    {#if data.storageSolutionsBackgroundImage.length > 0}
      <div class="w-full z-10" style="position: absolute; bottom: 0; height: 400px; background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 3%, #FFFFFF 62%); opacity: {1 - Math.max(0, y / 180)};"></div>

      <img  
        src="{data.storageSolutionsBackgroundImage[1].urls.src}"
        srcset="{data.storageSolutionsBackgroundImage[1].urls.srcset}"
        sizes="100vw"
        class="{data.blockCustomStyles}"
        alt=""
      >
    {/if}
  </div>

  <div style="position: absolute; bottom: 20px; width: 100%;" class="text-center">
    <div class="relative z-10" style="opacity: {1 - Math.max(0, y / 80)};">
      <slot></slot>
      <div class="svg-icon animate-bounce mt-4" style="color: {fontColor};">
        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="arrow-down" class="svg-inline--fa fa-arrow-down fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M443.5 248.5l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L241 419.9V44c0-6.6-5.4-12-12-12h-10c-6.6 0-12 5.4-12 12v375.9L28.5 241.4c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.8 4.8-12.3.1-17z"></path></svg>
      </div>
    </div>
  </div>

{:else}

  <div class="text-center" style="color: {fontColor}" id={id} data-aos="fade">
      {#if bgImage.length > 1}
        <img  
          src="{data.storageSolutionsBackgroundImage[1].urls.src}"
          srcset="{data.storageSolutionsBackgroundImage[1].urls.srcset}"
          sizes="100vw"
          class=""
          alt=""
        >

        <div style="padding: 10px 0; margin: bottom: 20px;">
          <slot></slot>
        </div>
      {/if}
  </div>

{/if}